import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionSheetController, AlertController, LoadingController, MenuController, ModalController, NavParams, PopoverController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
// import { ComFilterLeadsComponent } from '../com-filter-leads/com-filter-leads.component';
// import { UtilService } from '../services/util/util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-detail-pp',
  templateUrl: './detail-pp.component.html',
  styleUrls: ['./detail-pp.component.css']
})
export class DetailPpComponent implements OnInit {

 
  load: boolean = false;
  button: boolean = false;
  token: any;
  user: any;
  hasil: any;
  hsl: any;
  kw: any;

  selct: any = '';
  keterangan: any = '';
  absensiData: any;

  info: any = 'Daftar';

  checklists: any;

  foto: any = {};
  url: any = '';
  
  constructor(
    public popoverController: PopoverController,
    public modalController: ModalController,
    public menuCtrl: MenuController,
    public route: Router,
    public http: HttpClient,
    public loadingctrl: LoadingController,
    public alertctrl: AlertController,
    public util: UtilService,
    public activatedRoute: ActivatedRoute,
    public actionSheetController: ActionSheetController,
    public navParams: NavParams,
    public api: ApiService
  ) {

    this.kw = this.navParams.data.id;
    console.log('KW', this.kw);
  }

  ngOnInit() {
   this.getList();

  }

  navigate(){
    const lat = this.foto?.latitude;
    const lng = this.foto?.longitude;
    window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_system');
  }

  getList() {
    this.load = true;
    this.api.get('backoffice/pp/assigned/list/'+this.kw)
      .subscribe((data) => {
        this.hasil = data;
          
        this.hsl = this.hasil.data;
        this.load = false;

        this.absensiData = this.hsl?.members;
        this.checklists = this.hsl?.checklists;

        this.foto = this.hsl?.foto;
const lat = this.foto?.latitude;
    const lng = this.foto?.longitude;
    this.url = `https://www.google.com/maps?q=${lat},${lng}`;
       
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
  }

  batal(){
    this.modalController.dismiss();
  }


}
